// extracted by mini-css-extract-plugin
export default {"container":"TopMenu_container__bmPYw","links":"TopMenu_links__qwDW0","userInfo":"TopMenu_userInfo__+1bL2","name":"TopMenu_name__eulur","logoutBtn":"TopMenu_logoutBtn__n0nLC"};